import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW7200Component } from './kymw7200.component';
import { DeleteOperationGoodsService } from './api-services/delete-operation-goods.service';
import { GetOperationGoodsListService } from './api-services/get-operation-goods-list.service';
import { KYMW7201Module } from '../kymw7201/kymw7201.module';

/**
 * 運営商品一覧画面 モジュール設定クラス
 *
 * @export KYMW7200Module
 * @class KYMW7200Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    WjNavModule,
    WjGridModule,
    AppCommonsModule,
    KYMW7201Module,
  ],
  declarations: [
    KYMW7200Component,
  ],
  providers: [
    GetOperationGoodsListService,
    DeleteOperationGoodsService,
  ],
})

export class KYMW7200Module {

}
